<script lang="ts">
	//Design system components
	import { Button, Checkbox, Text } from '@Shelly/shelly-design-system';
	//Configs
	import { devices_config } from '@devices/index';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { get_mode, real_id } from 'src/helpers/interface_helpers';
	import { genCharArray } from 'src/helpers/utilities';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { onMount } from 'svelte';

	$: statusStore = getDeviceStatus(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let loading = false;
	const mode = get_mode(
		device,
		$settingsStore,
		$statusStore,
	);

	const phasesNumber = devices_config[device.type]?.modes?.[mode]?.phases;
	const phases = genCharArray(phasesNumber);
	let phasesSelected = {};

	onMount(() => {
		phases.forEach((phase) => {
			phasesSelected[phase] =
				$settingsStore?.['em:0']?.reverse?.[phase] || false;
		});
	});

	const selectPhaseTo = (phase) => {
		phasesSelected[phase] = !phasesSelected[phase];
	};

	const setMeasurement = async () => {
		loading = true;
		const res = await gen2Request(device, 'EM.SetConfig', {
			id: 0,
			config: {
				reverse: { ...phasesSelected },
			},
		});
		await onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Text class="mb-s" styleType="body-small"
	>{$format('emeter_invert_measurement_description', {
		default: 'Invert measurement direction in software per current transformer.',
	})}</Text
>
{#each phases as phase}
	<Checkbox
		class="mb-s"
		size="m"
		selected={phasesSelected[phase]}
		bind:checked={phasesSelected[phase]}
		value={phase}
		on:click={() => selectPhaseTo(phase)}
		id="checkbox-ewa13es">{$format(`label_phase_${phase}`, { default: `Phase ${phase}` })}</Checkbox
	>
{/each}

<Button {loading} width="full" size="m" on:click={setMeasurement}>{$format('button_save')}</Button>
